import { actions } from 'react/api/actions/eventHttpActionLogs';
import { fromJS } from 'immutable';

const initialState = fromJS({
  data: [],
  isLoading: false
});

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.updateEventHttpActionLogs: {
      const { data, shouldClearBeforeUpdateLogs } = action.payload;

      const updateLogs = (actualLogs) => actualLogs && !shouldClearBeforeUpdateLogs ?
        actualLogs.concat(data) : fromJS(data);

      return state.update('data', updateLogs);
    }
    case actions.setIsLoadingEventHttpLogs: {
      const { isLoading } = action.payload;

      return state.set('isLoading', isLoading);
    }
    case actions.clearEventHttpActionLogs:
      return state.set('data', fromJS([]));
    default:
      return state;
  }
};
